module.exports = __webpack_public_path__ + "static/07_ph_scale-d959e734ef5a8b8c808635ca1f7ffb06.jpg";